import { OneThread } from '@/components/prototype/one-thread';

export function WorkspacePage() {
  return <OneThread />;
}
